class BlogList {
    constructor(section) {
        this.root = section;

        this.init();
    }

    init() {
        this.loader = this.root.querySelector('.loader');
        this.htmlOutput = this.root.querySelector('[js-output]');
        this.pagination = this.root.querySelector('[js-pagination]');
        this.paginationCurrent = this.pagination.querySelector('[js-current]');
        this.paginationTotal = this.pagination.querySelector('[js-total]');
        this.progressBar = this.pagination.querySelector('[js-progress-bar]');
        this.paginationButton = this.pagination.querySelector(
            '[js-pagination-button-wrapper]'
        );
        this.form = this.root.querySelector('form');
        this.pageInput = this.form?.querySelector("[name='page']");
        this.perPageInput = this.form?.querySelector("[name='per_page']");
        this.isDesktopView = window.innerWidth > 1023.98;

        this.perPageInput.value = this.isDesktopView ? 6 : 3;

        this.events();
    }

    events() {
        if (this.form) {
            this.form.addEventListener('input', this.onFormReset.bind(this));
        }
        if (this.paginationButton) {
            this.paginationButton.addEventListener(
                'click',
                this.onPaginationButtonClick.bind(this)
            );
        }
        window.addEventListener('resize', this.onWindowResize.bind(this));
        window.addEventListener('load', this.onWindowLoad.bind(this));
    }

    onFormReset(e) {
        e.preventDefault();
        this.pageInput.value = 1;

        this.fetch();
    }

    onPaginationButtonClick() {
        this.pageInput.value = parseInt(this.pageInput.value) + 1;
        this.fetch(true);
    }

    onWindowResize() {
        const width = window.innerWidth;

        if (width > 1023.98 && !this.isDesktopView) {
            this.perPageInput.value = 6;
            this.isDesktopView = true;
        } else if (width <= 1023.98 && this.isDesktopView) {
            this.perPageInput.value = 3;
            this.isDesktopView = false;
        } else {
            return;
        }

        const items = this.root.querySelectorAll('[js-list-item]');
        if (items.length) {
            this.pageInput.value = 1;
            this.fetch();
        }
    }

    onWindowLoad() {
        if (!this.isDesktopView) {
            this.perPageInput.value = 3;
            this.fetch();
        }
    }

    async fetch(append = false) {
        try {
            this.loader.classList.add('active');
            const req = await fetch(ajax.url, {
                method: 'POST',
                body: new FormData(this.form),
            });

            const res = await req.json();

            const { html } = res.data;

            if (append) {
                this.htmlOutput.innerHTML += html;
            } else {
                this.htmlOutput.innerHTML = html;
            }

            this.handlePagination(res.data);
            const selectedRadio = this.form.querySelector(
                'input[name="type"]:checked'
            );
            if (selectedRadio) {
                const slug = selectedRadio.getAttribute('data-slug');
                const url = new URL(window.location.href);
                url.search = '';
                if (slug !== 'featured') {
                    url.searchParams.set('c', slug);
                }
                history.replaceState({}, '', url);
            }
        } catch (error) {
            console.log(error);
        } finally {
            this.loader.classList.remove('active');
        }
    }

    handlePagination(data) {
        const { total } = data;

        if (total == 0) {
            this.pagination.classList.add('hidden');
        } else {
            const items = this.root.querySelectorAll('[js-list-item]');
            this.pagination.classList.remove('hidden');
            this.paginationCurrent.textContent = items.length;
            this.paginationTotal.textContent = total;
            this.progressBar.style.width = `${(items.length / total) * 100}%`;

            if (items.length === total) {
                this.paginationButton.classList.add('hidden');
            } else {
                this.paginationButton.classList.remove('hidden');
            }
        }
    }
}

const sections = document.querySelectorAll('section.blog-list');

if (sections.length) {
    sections.forEach(section => {
        new BlogList(section);
    });
}
